/* eslint-disable prettier/prettier */
import {
  getPayments,
  IGetPayments,
  PaginatedResponse
} from '../../../domain/usecases/Payments'

import { HttpClient } from '../../protocols/http/httpClient'
import { Receivable } from '../../../domain/models/ReceivableModel'

export class RemoteGetPayments implements IGetPayments {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async getPayments(
    params?: getPayments.getPaymentsParams
  ): Promise<PaginatedResponse<Receivable>> {
    const httpResponse = await this.httpClient.get?.({
      url: `${this.url}/billings`,
      data: params
    })

    // API returns {data: [...], pagination: {...}}
    // Return full response so page component can access pagination
    if (httpResponse && httpResponse.data && httpResponse.pagination) {
      return httpResponse
    }

    // Legacy: if response is just an array
    if (httpResponse && Array.isArray(httpResponse.data)) {
      return httpResponse.data
    }

    return httpResponse
  }
}
